import _ from 'lodash'
import { daysToMs } from '@/utils/dates'

export function getIndexByKey(array, key, value) {
  return array.map((o) => o[key]).indexOf(value)
}

export function arrayToObject(array, cb) {
  return array.reduce((obj, value, i) => {
    obj[value] = cb(value)
    return obj
  }, {})
}

export function sleep(ms = 0) {
  return new Promise((r) => setTimeout(r, ms))
}

export async function delayed(promise, ms = 0) {
  await sleep(ms)
  return await promise
}

export function normalizeLink(link) {
  if (_.startsWith(link, 'http')) {
    return link
  } else {
    return `http://${link}`
  }
}

export function searchObjectsByKey(array, key, searchValue) {
  searchValue = _.escapeRegExp(searchValue)
  if (!searchValue) {
    return array
  } else {
    const re = new RegExp(searchValue, ['i'])
    return array.filter((o) => o[key].search(re) >= 0)
  }
}

export function uuid4() {
  // source: https://gist.github.com/jed/982883
  function b(
    a, // placeholder
  ) {
    return a // if the placeholder was passed, return
      ? // a random number from 0 to 15
        (
          a ^ // unless b is 8,
          ((Math.random() * // in which case
            16) >> // a random number from
            (a / 4))
        ) // 8 to 11
          .toString(16) // in hexadecimal
      : // or otherwise a concatenated string:
        (
          [1e7] + // 10000000 +
          -1e3 + // -1000 +
          -4e3 + // -4000 +
          -8e3 + // -80000000 +
          -1e11
        ) // -100000000000,
          .replace(
            // replacing
            /[018]/g, // zeroes, ones, and eights with
            b, // random hex digits
          )
  }
  return b().replace(/-/g, '')
}

export function omitEmptyKeys(obj) {
  const pairs = _.toPairs(obj)
  const newPairs = pairs.filter((pair) => {
    const [key, val] = pair
    if (val) {
      return true
    } else {
      return false
    }
  })
  return _.fromPairs(newPairs)
}

export function normalizeEmail(email) {
  return email.toLowerCase()
}

export function isEmail(text) {
  const emailRe = /\S+@\S+\.\S+/
  return emailRe.test(text)
}

export function htmlElementHasText(el) {
  const htmlEl = document.createElement('html')
  htmlEl.innerHTML = el

  return htmlEl.innerText.trim() !== ''
}

export function trimHtml(htmlText) {
  const el = document.createElement('body')
  el.innerHTML = htmlText

  while (el.lastElementChild && !el.lastElementChild.innerText.trim()) {
    el.lastElementChild.remove()
  }

  return el.innerHTML
}

export function pluraize(count, noun, suffix = 's') {
  return `${noun}${count !== 1 ? suffix : ''}`
}
